module.exports = __webpack_public_path__ + "vodafone.png?324eacd213a2fdf88413465826174452";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vodafone.png
// module id = 18
// module chunks = 0